import { create as createBackend, RealtimeSession, ClientLibraryType } from '@bett3r-dev/teselly-client-library';
import { createContext, ReactNode, useContext, useEffect, useState } from 'react';

type Props = { children: ReactNode };
export type BackendType = any;
export type BackendContextType = { 
    backend: ClientLibraryType, 
    setBackend: ( value: BackendType ) => void, 
    realTimeSession: RealtimeSession | null, 
    setRealTimeSession: ( value: RealtimeSession ) => void 
};

export const backendContext = createContext<BackendContextType | null>( null );


export function ProvideBackend({ children }: Props ) {
    const _backend = useProvideBackend() as BackendContextType;
    return <backendContext.Provider value={_backend}>{children}</backendContext.Provider>;
}

export default function useBackend() {
    return useContext( backendContext );
}

function useProvideBackend() {
    const [ backend, setBackend ] = useState<ReturnType<typeof createBackend> | null>();
    const [ realTimeSession, setRealTimeSession ] = useState<RealtimeSession | null>( null );

    useEffect(() => {
        const backendInstance = createBackend({ baseUrl: import.meta.env.VITE_BACKEND_URL || '', includeCredentials: true });
        setBackend( backendInstance );
    }, []);

    return {
        backend,
        setBackend,
        realTimeSession,
        setRealTimeSession
    };
}
